import React, { Component } from "react";

import TableWrapper from "../elements/TableWrapper";
import { Layout, message, Row, Col, Modal } from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";

const { Content } = Layout;
const { confirm } = Modal;

class TemplateManagement extends Component {
  constructor(props) {
    super(props);
    this.columnsdata = [
      {
        title: "Template Name",
        dataIndex: "template_Name",
        sorter: (a, b) => a.template_Name.localeCompare(b.template_Name),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Template Description",
        dataIndex: "template_Description",
        sorter: (a, b) =>
          a.template_Description.localeCompare(b.template_Description),
        sortDirections: ["descend", "ascend"],
      },

      {
        title: "Actions",
        render: (text, record) => {
          return (
            <div style={{ display: "flex", width: 20 }}>
              <>
                {" "}
                <i
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/addTemplate",
                      state: record.templateId,
                    });
                  }}
                  className="fa fa-pencil fa-b"
                  aria-hidden= "true"
                  hidden={record.is_Predefined?true:false}

                ></i>
                <i
                  onClick={() => this.DeleteSRTemplate(record["templateId"])}
                  className="fa fa-trash fa-red "
                  aria-hidden="true"
                  hidden={record.is_Predefined?true:false}

                ></i>
                <i
                  className="fa fa-eye fa-b"
                  aria-hidden="true"
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/viewTemplate",
                      state: record.templateId,
                    });
                  }}
                ></i>
              </>
            </div>
          );
        },
      },
    ];
    this.state = {
      allFieldsLoading: false,
      id: undefined,
      data: [],
      addTemp: this.props.addTemp,
      isLoading: this.props.isLoading,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllSRTemplate();
  }
  GetAllSRTemplate() {
    this.api.invoke("GetAllSRTemplate", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const field = data.data.templates;
          this.data = field;
          this.setState({ allFieldsLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  DeleteSRTemplate = (id) => {
    confirm({
      title: "Do you want to delete this Field?",
      onOk: () => {
        this.api.invoke("DeleteSRTemplate/" + id, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.setState({ isLoading: false });

              this.GetAllSRTemplate();
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        });
      },
      okText: "Yes",
      cancelText: "No",
      onCancel() {},
    });
  };

  render() {
    this.tableButtons = [
      {
        buttonType: "primary",
        content: "Add Template",
        clickHandler: () => {
          this.props.history.push("/addTemplate");
        },
      },
    ];

    return (
      <Content>     
          <div className="mi_main_div" >
          <Row span={24} style={{marginLeft:"10px",marginRight:"12px"}}>
            <Col span={24}>
            <TableWrapper
              rowKey="templateId"
              columns={this.columnsdata}
              data={this.state.allFieldsLoading ? null : this.data}
              loading={this.state.allFieldsLoading}
              buttons={this.tableButtons}
              title="Manage Templates"
              className="table-search-button.button"
              search={true}
            />
            </Col>
            </Row>
          </div>    
      </Content>
    );
  }
}

export default TemplateManagement;
